import { BackLink } from 'src/components/common'
import { routes } from 'src/navigation/routes'

export const Billing = () => (
  <>
    <div className="sectionHb-top">
      <BackLink to={routes.root} />
      <h2 className="sectionHb-title">Billing</h2>
    </div>

    <div className="sectionHb-block purchaseHb">
      <div className="sectionHb-block__wrap" />
    </div>
  </>
)
